import React from "react";
import logo from "./../../../assets/images/logo.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import BookIcon from "@mui/icons-material/Book";
import HistoryIcon from "@mui/icons-material/History";
import ForumIcon from "@mui/icons-material/Forum";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IoLogOutSharp } from "react-icons/io5";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AssignmentIcon from "@mui/icons-material/Assignment";
import TaskIcon from "@mui/icons-material/Task";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import GroupsIcon from '@mui/icons-material/Groups';
const SideMenuData = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let CurrentPagePath = location.pathname;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const isMatch = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <>
      {isMatch ? (
        <div></div>
      ) : (
        <div
          className="tutor-panel-sider-container"
          style={{ position: isMatch ? "" : "fixed" }}
        >
          <div className="tutor-panel-sider-content-wraper">
            <div className="tutor-panel-sider-logo-container">
              <img src={logo} alt="logo" width="100px" />
            </div>
            <div className="side-menu-data-list-main">
              <ul className="side-menu-ul">
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/dashboard"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/dashboard");
                    }}
                  >
                    <DashboardIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">dashboard</span>
                  </Button>
                </li>

                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/profile"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/profile");
                    }}
                  >
                    <PersonIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my profile</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/my-classes" ||
                      CurrentPagePath === "/tutor-panel/my-classes/view" ||
                      CurrentPagePath === "/tutor-panel/my-classes/live"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/my-classes");
                    }}
                  >
                    <BookIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my classes</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/class-history" ||
                      CurrentPagePath === "/tutor-panel/class-history/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/class-history");
                    }}
                  >
                    <HistoryIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Class History</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/chat"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/chat");
                    }}
                  >
                    <ForumIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">chat inbox</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/notifications" ||
                      CurrentPagePath === "/tutor-panel/notifications/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/notifications");
                    }}
                  >
                    <NotificationsActiveIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">notifications</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/my-wallet"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/my-wallet");
                    }}
                  >
                    <AccountBalanceWalletIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my wallet</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/dispute" ||
                      CurrentPagePath === "/tutor-panel/dispute/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/dispute");
                    }}
                  >
                    <PsychologyIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">dispute</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/salary-request" ||
                      CurrentPagePath === "/tutor-panel/salary-request/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/salary-request");
                    }}
                  >
                    <LocalAtmIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">salary request</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/lesson-plan" ||
                      CurrentPagePath === "/tutor-panel/lesson-plan/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/lesson-plan");
                    }}
                  >
                    <StickyNote2Icon className="side-menu-icon" />
                    <span className="side-menu-page-title">lesson plan</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/leave-request" ||
                      CurrentPagePath === "/tutor-panel/leave-request/create" ||
                      CurrentPagePath === "/tutor-panel/leave-request/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/leave-request");
                    }}
                  >
                    <LiveHelpIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">leave request</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/assignment" ||
                      CurrentPagePath === "/tutor-panel/assignment/create" ||
                      CurrentPagePath === "/tutor-panel/assignment/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/assignment");
                    }}
                  >
                    <AssignmentIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">assignment</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/attendance" 
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/attendance");
                    }}
                  >
                    <GroupsIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">attendance</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/submitted-task" ||
                      CurrentPagePath === "/tutor-panel/submitted-task/view" ||
                      CurrentPagePath === "/tutor-panel/submitted-task/create-result"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/submitted-task");
                    }}
                  >
                    <TaskIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">submitted task</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/result" ||
                      CurrentPagePath === "/tutor-panel/result/view" ||
                      CurrentPagePath === "/tutor-panel/result/edit" 
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/result");
                    }}
                  >
                    <FactCheckIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">result</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor-panel/transaction-history"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor-panel/transaction-history");
                    }}
                  >
                    <PointOfSaleIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">
                      transaction history
                    </span>
                  </Button>
                </li>
                <br />
              </ul>
            </div>
            <div className="first-tutor-panel-sider-log-out-container">
              <Button
                variant="text"
                className="logout-button"
                onClick={() => {
                  navigate("/");
                  window.location.reload();
                }}
              >
                <span>Logout</span>
                <IoLogOutSharp className="side-menu-icon" />
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default SideMenuData;
